<template>
  <div class="price-to-earning-ratio">
    <p v-if="whichLevelsNotHave.length > 0">
      {{ whichLevelsNotHave }}等級，尚無資料
    </p>
    <!-- :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc" -->
    <b-table
      :fields="fields"
      :items="hasLevelToFixedData"
      sort-icon-left
      data-checkbox="true"
      sticky-header
      head-variant="dark"
      hover
      small
      striped
    >
      <template v-slot:cell(EPS_price_earnings_ratio)="{ item }">
        {{ item.EPS_price_earnings_ratio === null ? 'NA' : item.EPS_price_earnings_ratio }}
      </template>
      <template v-slot:cell(EBIDTA_price_earning_ratio)="{ item }">
        {{ item.EBIDTA_price_earning_ratio === null ? 'NA' : item.EBIDTA_price_earning_ratio }}
      </template>
    </b-table>
  </div>
</template>

<script>
const LEVEL_RULES = ["A", "B", "C", "D"];
export default {
  data() {
    return {
      // sortBy: "count",
      // sortDesc: false,
      fields: [
        { key: "level", label: "等級", sortable: true },
        {
          key: "EPS_price_earnings_ratio",
          label: "近四季每股 EPS 本益比(元)",
          sortable: true
        },
        {
          key: "EBIDTA_price_earning_ratio",
          label: "近四季每股 EBIDTA 本益比(元)",
          sortable: true
        },
        {
          key: "count",
          label: "家數",
          sortable: true
        }
      ]
    };
  },
  computed: {
    hasLevelToFixedData() {
      let hasLevelData = this.$store.getters.priceToEarningRatio.filter(
        item => {
          // 舉例：在分公司等級時，有可能等級 C 完全沒有公司
          if (item.level) return item;
        }
      );
      let toFixedData = hasLevelData.map(item => {
        return {
          ...item,
          EPS_price_earnings_ratio: item.EPS_price_earnings_ratio.toFixed(2),
          EBIDTA_price_earning_ratio: item.EBIDTA_price_earning_ratio.toFixed(2)
        };
      });
      const data = toFixedData.sort((a, b) => {
        if (a.level < b.level) return -1;
        else if (a.level > b.level) return 1;
        return 0;
      });
      const allItem = data.find(item => item.level === "All");
      const otherItems = data.filter(item => item.level !== "All");
      return [allItem, ...otherItems];
    },
    hadLevel() {
      return this.hasLevelToFixedData.map(item => item.level);
    },
    whichLevelsNotHave() {
      return LEVEL_RULES.filter(level => {
        if (!this.hadLevel.includes(level)) return level;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.price-to-earning-ratio {
  p {
    padding-left: 20px;
  }
}
</style>
